const TEXT = "Lote Promocional até 30 de Dezembro/2026 • Pregoeiros Summit 2027 • ";

const Row = () => (
  <div className="flex items-center shrink-0">
    {Array.from({ length: 4 }).map((_, i) => (
      <span
        key={i}
        className="font-display font-extrabold uppercase tracking-[0.08em] text-sm sm:text-base text-brand-deep whitespace-nowrap px-2"
      >
        {TEXT}
      </span>
    ))}
  </div>
);

export default function EditorialMarquee() {
  return (
    <div
      className="relative py-4 sm:py-5 bg-gradient-to-r from-brand-blue via-brand-cyan to-brand-blue border-y border-white/15 shadow-[0_14px_44px_rgba(3,10,26,0.45)] overflow-hidden marquee-viewport"
      data-testid="lot-marquee"
    >
      <div className="marquee-track" style={{ animationDuration: "45s" }}>
        <Row />
        <Row />
      </div>
    </div>
  );
}
